export enum ICQueries {
  ICTable = 'ICTable',
  SearchICElement = 'searchICElement',
}
